import { useEffect, useState } from 'react'
import { SketchPicker } from 'react-color'
import Dialog from '@mui/material/Dialog'
import { DialogActions, DialogContent, FormHelperText, Paper } from '@mui/material'
import IconTooltipButton from '../../button/IconTooltipButton'

/* 	InputColor
 *	@params id 			string	 	identificador input
 *	@params value		any type	value input
 *	@params disabled	bool		disabled input
 *	@params onChange	function 	function change
 */

const InputColor = ({
  id,
  value,
  onChange,
  disabled,
  error,
  size = 'size-8',
  short = false,
  showDelete = true
}) => {
  const [showColors, setShowColors] = useState(false)
  const [color, setColor] = useState(value || '')

  useEffect(() => {
    setColor(value || '')
  }, [value])

  return (
    <>
      <div className='bg-muted rounded p-1 flex gap-1 items-center justify-between'>
        <div
          id={id}
          className={`${size} rounded ${value ? '' : ' bg-lines'}`}
          style={{ backgroundColor: value }}
          onClick={disabled ? undefined : () => setShowColors(!showColors)}
          onBlur={() => setShowColors(false)}
        />
        {!short && (
          <span className='text-muted-foreground text-nowrap text-ellipsis' style={{ width: 100 }}>
            {value || 'No color'}
          </span>
        )}
        {!disabled && showDelete && (
          <IconTooltipButton
            id={`delete-color-${id}`}
            title='Remove color'
            icon='trash-alt'
            disabled={disabled}
            onClick={() => onChange('')}
            style={{
              width: 25,
              height: 25,
              padding: '0.45rem'
            }}
          />
        )}
      </div>
      {error && <FormHelperText error={!!error}>{error}</FormHelperText>}
      {showColors && (
        <Dialog open={showColors} style={{ backgroundColor: 'transparent' }}>
          <DialogContent>
            <SketchPicker
              styles={{
                picker: {
                  padding: 0,
                  width: 300
                }
              }}
              width={200}
              direction='horizontal'
              id={`picker-${id}`}
              color={color}
              onChangeComplete={(value) => setColor(value.hex)}
            />
          </DialogContent>
          <DialogActions>
            <IconTooltipButton title='Cancel' icon='times' onClick={() => setShowColors(false)} />
            <IconTooltipButton
              color='primary'
              title='Apply'
              icon='check'
              onClick={() => {
                onChange(color)
                setShowColors(false)
              }}
            />
          </DialogActions>
        </Dialog>
      )}
    </>
  )
}

export default InputColor
